import React, { Component } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { Settings, TextSnippet } from '@mui/icons-material';
import AutoReplyTeleSettings from './AutoReplyTeleSettings';
import AutoReplyTeleTemplates from './AutoReplyTeleTemplates';

class AutoReplytele extends Component {
    state = {
        activeTab: 'tab-settings',
    }

    handleTabChange = (event, newValue) => {
        this.setState({ activeTab: newValue });
    }

    render() {
        const { activeTab } = this.state;

        return (
            <Box>
                <Box sx={{ mb: 1 }}>
                    <Tabs
                        value={activeTab}
                        onChange={this.handleTabChange}
                        aria-label="auto reply tele tabs"
                        variant="fullWidth"
                        TabIndicatorProps={{ sx: { display: 'none' } }}
                        sx={{
                            minHeight: 40,
                            p: 0.5,
                            width: '100%',
                            bgcolor: '#f0f2f5',
                            borderRadius: '8px',
                            '& .MuiTabs-flexContainer': {
                                gap: 0.5,
                            },
                            '& .MuiTab-root': {
                                minHeight: 36,
                                borderRadius: '8px',
                                fontWeight: 600,
                                textTransform: 'none',
                                fontSize: '0.85rem',
                                color: 'text.secondary',
                                transition: 'all 0.25s ease',
                                '&:hover': {
                                    color: 'text.primary',
                                },
                            },
                            '& .MuiTab-root.Mui-selected': {
                                color: '#fff',
                                bgcolor: 'primary.main',
                                boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                            },
                        }}
                    >
                        <Tab icon={<Settings sx={{ fontSize: 18 }} />} iconPosition="start" label="Setting" value="tab-settings" />
                        <Tab icon={<TextSnippet sx={{ fontSize: 18 }} />} iconPosition="start" label="Templates" value="tab-templates" />
                    </Tabs>
                </Box>

                <Box sx={{ mt: '10px' }}>
                    {activeTab === 'tab-settings' && <AutoReplyTeleSettings />}
                    {activeTab === 'tab-templates' && <AutoReplyTeleTemplates />}
                </Box>
            </Box>
        );
    }
}

export default AutoReplytele;
